// Copy de la bandeja (PP-34), en tablas de etiquetas: la logica no compara
// mensajes y los tests de componente buscan estos textos en pantalla.
//
// Ningun texto nombra a otro proveedor: si un viaje se va, se dice que paso
// "a otro proveedor", nunca a cual (PLAN-ASIGNACION-PROVEEDOR §9).
import type { OfferRejectReason, TripAssignmentStatus, TripStatus } from "@ucorp/contracts";
import type { RequestsErrorKind } from "./port.js";

export const REJECT_REASON_LABEL: Record<OfferRejectReason, string> = {
  no_vehicle_available: "Sin vehículo disponible",
  no_driver_available: "Sin conductor disponible",
  schedule_conflict: "Conflicto de horario",
  out_of_service_area: "Fuera de la zona de servicio",
  other: "Otro motivo",
};

export const REJECT_REASONS: readonly OfferRejectReason[] = [
  "no_vehicle_available",
  "no_driver_available",
  "schedule_conflict",
  "out_of_service_area",
  "other",
];

export const ASSIGNMENT_STATUS_LABEL: Record<TripAssignmentStatus, string> = {
  unoffered: "Del armado, sin oferta",
  offered: "Oferta para responder",
  accepted: "Aceptado, falta asignar",
  assigned: "Asignado",
  exhausted: "Fuera de la bandeja",
  void: "Anulado",
};

export const TRIP_STATUS_LABEL: Record<TripStatus, string> = {
  scheduled: "Programado",
  in_progress: "En curso",
  completed: "Terminado",
  cancelled: "Cancelado",
};

/** Copy de un error al operar un viaje (aceptar, rechazar o asignar). */
export const ACTION_ERROR_COPY: Record<RequestsErrorKind, string> = {
  access: "La cuenta no tiene permiso para esta operación en esta planta, o el vehículo o el conductor no son de la empresa.",
  not_found: "El viaje ya no está en la bandeja de la empresa. La bandeja se actualizó.",
  offer_not_open:
    "La oferta ya no está abierta: se venció el tiempo para responder o ya fue respondida. Si se venció, el viaje pasó a otro proveedor.",
  offer_not_yours: "La oferta ya no es de la empresa: el viaje pasó a otro proveedor.",
  trip_not_assignable:
    "El viaje ya no se puede asignar: se venció el tiempo para asignar, la planta lo canceló o el viaje ya empezó.",
  roster_entry_unknown:
    "El vehículo o el conductor elegido no está en la nómina de la empresa en esta planta. Revisar la nómina y elegir de nuevo.",
  conflict: "El viaje cambió mientras se operaba. La bandeja se actualizó.",
  validation: "La operación no se pudo enviar. Actualizar la bandeja e intentar de nuevo.",
  unavailable: "No se pudo completar la operación. Reintentar en unos minutos.",
};
